import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { QueryVhweb } from 'private-angular-vhframeworks';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  @Input() id_parent;
  @ViewChild('video',{static:true}) video:ElementRef<HTMLDivElement>;
  videoUrl:string = 'https://www.youtube.com/embed/'
  widthVideo:number;
  public path: any;
  constructor(
    private queryVhweb: QueryVhweb,
    private _sanitizer: DomSanitizer
  ) { 
  }

  ngOnInit(): void {
    this.getData();
    this.widthVideo =this.video.nativeElement.getBoundingClientRect().width -30;
    
  }

  getData() {
    this.queryVhweb.getComponents('home-video', this.id_parent)
      .then(res => {
        
        this.path = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl+ res.docs[0].data().path);
      })
  }

}
